import payload_plugin_qLmFnukI99 from "/nuxt-app/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/nuxt-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/nuxt-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/nuxt-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/nuxt-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/nuxt-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/nuxt-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/nuxt-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/nuxt-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ghbUAjaD3n from "/nuxt-app/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import mask_plugin_3LIh79TWmZ from "/nuxt-app/modules/mask/runtime/plugin/mask.plugin.ts";
import vuetify_plugin_u5jU6XzrZj from "/nuxt-app/modules/vuetify/runtime/plugin/vuetify.plugin.ts";
import plugin_2TTjvwQPRx from "/nuxt-app/node_modules/nuxt-csurf/dist/runtime/plugin.js";
import _01_featureFlags_OjDM67CYOW from "/nuxt-app/plugins/01.featureFlags.ts";
import hash_intersect_directive_euZimn94Rm from "/nuxt-app/plugins/hash-intersect-directive.ts";
import yandex_metrika_client_MiNHrQhx1f from "/nuxt-app/plugins/yandex-metrika.client.ts";
import ymapPlugin_client_R23tn3Xd64 from "/nuxt-app/plugins/ymapPlugin.client.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ghbUAjaD3n,
  mask_plugin_3LIh79TWmZ,
  vuetify_plugin_u5jU6XzrZj,
  plugin_2TTjvwQPRx,
  _01_featureFlags_OjDM67CYOW,
  hash_intersect_directive_euZimn94Rm,
  yandex_metrika_client_MiNHrQhx1f,
  ymapPlugin_client_R23tn3Xd64
]